module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-fog-fill-defc2bd0.svg";